/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { memo } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import {
  RiFacebookCircleLine,
  RiInstagramLine,
  RiWhatsappLine,
  RiYoutubeLine,
  RiChat4Fill,
} from "react-icons/ri";
import { ExternalLink } from "react-external-link";
import { FaRegUserCircle, FaWhatsapp } from "react-icons/fa";
import logo from "../../../logo.svg";

import { BsPinMap, BsPhone } from "react-icons/bs";
import { FiMail } from "react-icons/fi";

import Socialmedia from "../SocialMedia/SocialMedia";
const socialnetworks = [
  {
    url: "https://api.whatsapp.com/send?phone=16314885832",
    icon: <RiWhatsappLine className="mr-2" size={32} />,
    text: "Whatsapp",
    bgColor:"#28D146",
  },
  {
    url: "https://www.facebook.com/",
    icon: <RiFacebookCircleLine className="mr-2" size={32} />,
    text: "Facebook",
    bgColor:"#1877f2",
  },
  {
    url: "https://www.instagram.com/",
    icon: <RiInstagramLine className="mr-2" size={32} />,
    text: "Instagram",
    bgColor:"linear-gradient(45deg, #405de6,#5851db, #833ab4, #c13584, #e1306c, #fd1d1d)",
  },
  {
    url: "https://www.youtube.com/",
    icon: <RiYoutubeLine className="mr-2" size={32} />,
    text: "Youtube",
    bgColor:"#ff0000",
  },
];

const WrapperFooter = styled.footer`
  background: ${(props) => props.theme.colors.tertiary};
  background-size: cover;
  color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.light};
  background: ${(props) => props.theme.colors.primary};
  display:flex;
  justify-content: center;
  padding-top: 20px;
  padding-left: 100px;
  padding-right: 100px;
  padding-bottom: 10px;
  @media (max-width: 1200px) {
    padding-left: 18px;
    padding-right: 18px;
  }
`;
const TitleSpan = styled.span`
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: ${(props) => props.theme.typography.fontSize};
  text-align: left;
  font-weight: 600;
`;
const ListInfo = styled.ul`
  list-style: none;
  text-align: left;
  padding-left: 0;
  display: grid;
  margin-top: 10px;
`;

const LinkHorario = styled(Link)`
  color:#fff;
  text-decoration: none;
  &:hover {
    color: ${(props) => props.theme.colors.secondary};
  }
`;
const CopyrightStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.colors.light};
  background: ${(props) => props.theme.colors.secondary};
  background-size: cover;
  padding: 10px;
  font-size: small;
  width: 100%;
`;

const SocialMediaStyle = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  color: ${(props) => props.theme.colors.light};
  background: ${(props) => props.theme.colors.primary};
  background-size: cover;
  padding: 20px;
  font-size: small;
  width: 100%;
`;

const Footer = () => {
  const date = new Date();
  const yyyy = date.getFullYear();
  return (
    <>
    <SocialMediaStyle></SocialMediaStyle>
      <WrapperFooter>
        <div className="row g-4 text-center">
          <div className="col-12 col-md-3 col-lg-2 col-xl-2 col-sm-12 text-start">
            <TitleSpan>ABOUT US</TitleSpan>
            <ListInfo>
              <LinkHorario to="/aboutus#mission">
                <li>Mission</li>
              </LinkHorario>
              <LinkHorario   >
                <li>Visión</li>
              </LinkHorario>
              <LinkHorario to="/aboutus#values">
                <li>Values</li>
              </LinkHorario>
            </ListInfo>
          </div>
          <div className="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 text-start">
            {" "}
            <TitleSpan>OUR SERVICES</TitleSpan>
            <ListInfo>
              {/* <li>Clinica Brasil</li> */}
              <li>FINISH CARPENTRY</li>
              <li>ROOFING & SIDING</li>
              <li> FRAMING RENOVATIONS</li>
              <li>ADDITIONS</li>
              <li>DECKS</li>
              <li>OTHER</li>
            </ListInfo>
          </div>
          <div className="col-12 col-md-4 col-lg-4 col-xl-4 col-sm-12 text-start">
            <TitleSpan>CONTACT INFORMATION</TitleSpan>
            <ListInfo>
              <li>
                {" "}
                <BsPinMap /> P.O.BOX 2 HAMPTOM BAYS. NY 1194
              </li>
              <li>
                {" "}
                <BsPhone /> 631-488-5832{" "}
              </li>
              <li>
                {" "}
                <FiMail /> constructiondgpus@gmail.com{" "}
              </li>
            </ListInfo>
          </div>
          <div className="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 text-start">
            <TitleSpan>MEDIA</TitleSpan>
            <Socialmedia itemsMedia={socialnetworks}/>
          </div>
        </div>
      </WrapperFooter>
      {/* Copyrigth */}
      <CopyrightStyle>
        <span>
          <b>Copyright ©{yyyy} DGP CONSTRUCTION.</b> Todos los derechos
          reservados.
        </span>
        <br />
        <br />
        <div>
          <b>Created by Karen Nuñez</b>
        </div>
      </CopyrightStyle>
    </>
  );
};

export default memo(Footer);
